import { render, staticRenderFns } from "./Template-04.vue?vue&type=template&id=36a1c42e&"
import script from "./Template-04.vue?vue&type=script&lang=js&"
export * from "./Template-04.vue?vue&type=script&lang=js&"
import style0 from "./Template-04.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports